// extracted by mini-css-extract-plugin
module.exports = {"plusOne":"PlusOne_plusOne__3urRW"};